import { Link } from '@solidjs/meta';

export function Alatsi()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Alatsi&display=swap' rel='stylesheet' />
	</>);
}
